export default {
  tableHeader: {
    observationCount: 'Ilość',
  },
  empty: 'Nie znaleziono obserwacji',
};
